import styled from 'styled-components'

const SpinnerStyled = styled.div<{ $spinnerColor: 'white' | 'blue' }>`
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;

  .spinner-css {
    font-size: 1rem;
    animation: fadeIn 1s;
  }

  .spinner-css__bars {
    width: auto;
    height: 26px;
    text-align: center;
    margin: 0 auto;
  }

  .spinner-css__bars > i {
    background-color: #fff;
    background-color: ${({ $spinnerColor, theme }) =>
      $spinnerColor === 'blue' ? theme.colors.icon.active : theme.colors.background.white};
    height: 100%;
    width: 7px;
    margin-right: 0.3em;
    display: inline-block;
    animation: stretchdelay 1s infinite ease-in-out;
  }

  .spinner-css__bars > i:nth-child(1) {
    animation-delay: -0.4s;
  }

  .spinner-css__bars > i:nth-child(2) {
    animation-delay: -0.3s;
  }

  .spinner-css__bars > i:nth-child(3) {
    animation-delay: -0.2s;
  }

  .spinner-css__bars > i:nth-child(4) {
    animation-delay: -0.1s;
  }

  @keyframes stretchdelay {
    0%,
    100%,
    80% {
      transform: scaleY(0.3333);
    }

    40% {
      transform: scaleY(1);
    }
  }
`

export interface SpinnerProps {
  spinnerColor?: 'white' | 'blue'
  testId?: string
}

export const Spinner = ({ spinnerColor = 'white', testId }: SpinnerProps) => (
  <SpinnerStyled $spinnerColor={spinnerColor} data-testid={testId}>
    <div className='spinner-css'>
      <div className='spinner-css__bars'>
        <i></i>
        <i></i>
        <i></i>
        <i></i>
        <i></i>
      </div>
    </div>
  </SpinnerStyled>
)
